import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import EditTestimonialForm from '../Components/Testimonial/EditTestimonialForm'
import { addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config'
import { useParams, useNavigate } from 'react-router-dom'
const EditTestimonial = () => {
    const {id} = useParams()
    const navigate = useNavigate()
    const [name, setName] = useState("")
    const [designation, setDesignation] = useState("")
    const [content, setContent] = useState("")
    const [video, setVideo] = useState("")
    const [videoThumbnail, setVideoThumbnail] = useState("")
    const addVideo = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `testimonial/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setVideo(downloadURL)
        
       });
     }
   );
   }
   const addImage = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `testimonial/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setVideoThumbnail(downloadURL)
        
       });
     }
   );
   }
    const addTestimonial = () =>{
        const docRef = doc(db, "testimonial",id);
        updateDoc(docRef,{
       name: name,
       designation:designation,
       content:content,
       video:video,
       videoThumbnail:videoThumbnail
    })
    setName("")
    setDesignation("")
    setContent("")
    setVideo("")
    setVideoThumbnail("")
    navigate("/testimonials")
    }
    const fetchTestimonial = async () =>{
        const docRef = doc(db, "testimonial", id);
    const docSnap = await getDoc(docRef);
      
if (docSnap.exists()) {
  console.log("Document data:", docSnap.data());
  const data = docSnap.data()
  setName(data?.name)
  setDesignation(data?.designation)
  setContent(data?.content)
  setVideo(data?.video)
  setVideoThumbnail(data?.videoThumbnail)
    }
   
}
    useEffect(() => {
      fetchTestimonial()
    }, [])
    
  return (
    <div>
        <MultiLevelSidebar />
        <EditTestimonialForm 
        name={name} setName={setName}
         designation={designation} setDesignation={setDesignation} 
         content={content} setContent={setContent}
         video={video} setVideo={setVideo}
         videoThumbnail={videoThumbnail} setVideoThumbnail={setVideoThumbnail}
         addTestimonial={addTestimonial}
         addImage={addImage} addVideo={addVideo} />
    </div>
  )
}

export default EditTestimonial